document.addEventListener("DOMContentLoaded", () => {

  const popup = document.getElementById("newsletter-popup")
  const close_button = document.getElementById("close-newsletter-popup")

  if (popup) {

  const type = popup.dataset.openType;
  const time = popup.dataset.seconds;
  // const time = 0.1; // debug
  const depth = popup.dataset.depth;
  const content = popup.dataset.content;

  close_button.addEventListener("click", closeNewsletterPopup);

  const open_newsletter_btns = document.querySelectorAll('.open-newsletter-btn');

  if (open_newsletter_btns.length > 0) {
    open_newsletter_btns.forEach(btn => {
      btn.addEventListener('click', function(e) {
        openNewsletterPopup(e);
      });
    });
  }
  
  if (localStorage.getItem("popup-content") == JSON.stringify(content)) {
    return;
  }

  if (type == "depth") {
    window.addEventListener('scroll', calculateDistance);
  }

  if (type == "time") {
    let ms = time * 1000;
    setTimeout(openNewsletterPopup, ms);
  }

  // Calculate scroll distance from top
  function calculateDistance() {
    const pageHeight = document.documentElement.scrollHeight;
    const progress = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);

    // Calculate percents
    const currentScroll = (progress / (pageHeight - window.innerHeight)) * 100;

    if (depth < currentScroll) {
      openNewsletterPopup();
      removeEventListener('scroll', calculateDistance)
    }
  }

  // Close popup
  function closeNewsletterPopup() {
    popup.classList.remove("visible");
    document.body.classList.remove("popup-open");
  }

  // Open popup
  function openNewsletterPopup(e) {
    if (typeof e === 'undefined') {
      if (localStorage.getItem("popup-content") == JSON.stringify(content)) {
        return;
      }
    }

    popup.classList.add("visible");
    document.body.classList.add("popup-open");
    localStorage.setItem("popup-content", JSON.stringify(content));
  }
}
});